import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as ChatActions from './chat.actions';
import { ChatService } from '../services/chat.service';

@Injectable()
export class ChatEffects {

  sendChatMessage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ChatActions.SendChatMessage),
      switchMap(({ payload: { id, message } }) => {
        return this.chatService.sendChatMessage(id, message).pipe(
          map(data => ChatActions.SendChatMessageSuccess({ data })),
          catchError(error => of(ChatActions.SendChatMessageFailure({ error }))))
      })
    );
  });

  deleteChatMessage$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ChatActions.DeleteChatMessage),
      switchMap(({ payload: { id, blockUser } }) => {
        return this.chatService.deleteChatMessage(id, blockUser).pipe(
          map(data => ChatActions.DeleteChatMessageSuccess({ data })),
          catchError(error => of(ChatActions.DeleteChatMessageFailure({ error }))))
      })
    );
  });

  ublockChatAttendee$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ChatActions.UnblockChatAttendee),
      switchMap(({ payload: { id } }) => {
        return this.chatService.ublockChatAttendee(id).pipe(
          map(data => ChatActions.UnblockChatAttendeeSuccess({ data })),
          catchError(error => of(ChatActions.UnblockChatAttendeeFailure({ error }))))
      })
    );
  });

  constructor(
    private actions$: Actions,
    private chatService: ChatService
  ) {}
}
